const INVALID_NAME_TOKENS = new Set(['undefined', 'null']);

export const sanitizeNamePart = (value: unknown): string => {
  if (typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (INVALID_NAME_TOKENS.has(trimmed.toLowerCase())) return '';
  return trimmed.replace(/\s+/g, ' ');
};

export const buildDisplayName = (firstName?: unknown, lastName?: unknown, fallback = ''): string => {
  const parts = [sanitizeNamePart(firstName), sanitizeNamePart(lastName)].filter(Boolean);
  return parts.join(' ') || fallback;
};
